import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Lock, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, formData);
      const { token, admin_id, email } = response.data;

      // Store token in localStorage
      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_id', admin_id);
      localStorage.setItem('admin_email', email);

      toast.success('Login effettuato con successo!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Credenziali non valide. Riprova.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#222222] relative" data-testid="admin-login-page">
      <div className="art-deco-pattern" />
      
      <div className="relative z-10 w-full max-w-md px-4">
        <div className="text-center mb-8">
          <h1
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            <span className="text-[#FFDA00]">Rovèscio</span>
          </h1>
          <p className="text-gray-400">Pannello Amministratore</p>
        </div>

        <div className="card">
          <h2 className="text-2xl font-bold text-white mb-6 text-center">Login Admin</h2>
          
          <form onSubmit={handleSubmit} data-testid="admin-login-form">
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2 text-gray-300">
                <Mail className="inline mr-2" size={16} />
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="input-field"
                placeholder="admin@rovescio.it"
                data-testid="admin-email-input"
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium mb-2 text-gray-300">
                <Lock className="inline mr-2" size={16} />
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="input-field"
                placeholder="••••••••"
                data-testid="admin-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn-primary w-full"
              data-testid="admin-login-button"
            >
              {isLoading ? 'Accesso in corso...' : 'Accedi'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-[#FFDA00] hover:underline text-sm"
              data-testid="back-to-home-link"
            >
              ← Torna al sito
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
